import { Box, Typography } from "@bca/ui-library";
import { useRouter } from "next/router";
import React, { useCallback, useEffect } from "react";

import FilterSkeleton from "../loading-skeleton/FilterSkeleton";
import addFiltersToPageUrl from "./addFiltersToPageUrl";
import CheckboxWithBadge from "./CheckboxWithBadge";
import { FilterAsCheckbox } from "./FilterAsCheckbox";
import { filterDisclaimers } from "./filtersConfig";
import getFilterLabel from "./getFilterLabel";

let timer;

const gradeIcon = {
  "grade 1": {
    color: "#009D45",
    text: "1",
  },
  "grade 2": {
    color: "#00C546",
    text: "2",
  },
  "grade 3": {
    color: "#A7DC26",
    text: "3",
  },
  "grade 4": {
    color: "#FCC800",
    text: "4",
  },
  "grade 5": {
    color: "#F56600",
    text: "5",
  },
  "retail ready": {
    color: "#152D6D",
    text: "R",
  },
};

const GradeFacet = ({
  filteredSubfilters,
  appliedCheckboxes,
  setAppliedCheckboxes,
  setSelectedVehicles,
}) => {
  const hasConditionReport = appliedCheckboxes.find(
    (item) =>
      (item.categoryKey === "HasConditionReport" ||
        item.categoryKey === "hasconditionreport") &&
      item.filterKey === "true"
  );

  const router = useRouter();

  const stringifiedFilters = JSON.stringify(appliedCheckboxes);
  const debounceUrlUpdate = useCallback(() => {
    clearTimeout(timer);

    timer = setTimeout(() => {
      const newUrl = addFiltersToPageUrl("bq", appliedCheckboxes);
      const currentPageUrl = new URL(window.location.href);
      if (newUrl.href === currentPageUrl.href) {
        return;
      }
      newUrl.searchParams.delete("page");
      newUrl.searchParams.delete("vrm");
      router.push(newUrl.href, newUrl.href, { shallow: true });
    }, 1000);
  }, [stringifiedFilters, appliedCheckboxes, router]);

  useEffect(() => {
    debounceUrlUpdate();
  }, [stringifiedFilters, debounceUrlUpdate]);

  const onChange = (filterKey, categoryKey) => {
    setSelectedVehicles([]);
    let newState = null;
    const filterAlreadyApplied = appliedCheckboxes.find(
      (item) =>
        item.filterKey.toLowerCase() === filterKey.toLowerCase() &&
        item.categoryKey.toLowerCase() === categoryKey.toLowerCase()
    );

    if (filterAlreadyApplied) {
      newState = [
        ...appliedCheckboxes.filter((item) => item !== filterAlreadyApplied),
      ];
    } else {
      newState = [
        ...appliedCheckboxes,
        {
          filterKey: filterKey,
          categoryKey: categoryKey,
          groupedBy: "",
          parentFilterKey: "",
        },
      ];
    }

    setAppliedCheckboxes([...newState]);
  };

  const onChangeConditionReport = (categoryKey) => {
    setSelectedVehicles([]);
    let newState = null;

    const filterAlreadyApplied = appliedCheckboxes.find(
      (item) => item.categoryKey.toLowerCase() === categoryKey.toLowerCase()
    );

    if (filterAlreadyApplied) {
      newState = [
        ...appliedCheckboxes.filter((item) => item !== filterAlreadyApplied),
      ];
    } else {
      newState = [
        ...appliedCheckboxes,
        {
          filterKey: "true",
          categoryKey: "HasConditionReport",
          groupedBy: "",
          parentFilterKey: "",
        },
      ];
    }

    setAppliedCheckboxes([...newState]);
  };

  return (
    <>
      {!filteredSubfilters && <FilterSkeleton pairCount={2} />}
      {filteredSubfilters?.map(({ filterKey, filterValues }) => {
        const isFilterKey =
          filterValues?.length === 1 && filterValues[0].name === filterKey;
        if (isFilterKey) {
          const disclaimerText = filterDisclaimers.find(
            (discText) =>
              discText.filterKey.toLowerCase() === filterKey.toLowerCase() &&
              (discText.categoryKey === "Grade" ||
                discText.categoryKey === "grade")
          )?.disclaimerText;
          return (
            <Box key={filterKey}>
              <CheckboxWithBadge
                key={filterKey}
                filterKey={filterKey}
                count={filterValues[0].count}
                iconColor={gradeIcon[filterKey.toLowerCase()]?.color}
                iconText={gradeIcon[filterKey.toLowerCase()]?.text}
                onChange={() => onChange(filterKey, "Grade")}
                isSelected={Boolean(
                  appliedCheckboxes.find(
                    (item) =>
                      item.filterKey.toLowerCase() ===
                        filterKey.toLowerCase() &&
                      (item.categoryKey === "Grade" ||
                        item.categoryKey === "grade")
                  )
                )}
              ></CheckboxWithBadge>
              {disclaimerText && (
                <Typography
                  color="grey-blue"
                  variant="caption"
                  fontWeight="light"
                  ml={9}
                  css={`
                    max-width: 292px;
                  `}
                >
                  {disclaimerText}
                </Typography>
              )}
            </Box>
          );
        } else return null;
      })}
      <FilterAsCheckbox
        key={hasConditionReport?.filterKey}
        id={hasConditionReport?.filterKey}
        label={getFilterLabel("HasConditionReport", "true")}
        isSelected={Boolean(hasConditionReport?.filterKey)}
        onChange={() => onChangeConditionReport("HasConditionReport")}
      />
    </>
  );
};

export default GradeFacet;
